import { string, object, ref } from 'yup';

const schema = object().shape({
  password: string().required('requiredField').min(6, 'minSixCharacters'),
  passwordConfirmation: string().required('requiredField').oneOf([ref('password'), null], 'passwordNotMatch')
});

export default schema;